import React from 'react';
import { Group } from '@visx/group';
import { ParentSize } from '@visx/responsive';
import { scaleLinear } from '@visx/scale';
import type { HomeDashboard } from '../../../api/homeV3Api';
import styles from '../HomeV3.module.css';

interface Props { exercises: HomeDashboard['exercises']; }

export function TargetingProgressChart({ exercises }: Props) {
    if (exercises.length === 0) return <div className={styles.chartEmpty}>No active exercise schedule to display.</div>;
    const rowHeight = 46;
    const chartHeight = Math.max(130, exercises.length * rowHeight + 20);

    return (
        <div>
            <div className={styles.targetingChart} style={{ height: chartHeight }}>
                <ParentSize debounceTime={50}>{({ width, height }) => {
                    const labelWidth = Math.min(130, width * 0.38);
                    const barWidth = Math.max(1, width - labelWidth - 55);
                    return (
                        <svg width={width} height={height} role="img" aria-label="Active targeting exercise schedule progress">
                            {exercises.map((exercise, index) => {
                                const scale = scaleLinear({ domain: [0, exercise.progressTotal], range: [0, barWidth], clamp: true });
                                const percent = Math.min(100, Math.round((exercise.progressCurrent / exercise.progressTotal) * 100));
                                const y = index * rowHeight + 12;
                                return (
                                    <Group key={exercise.id} top={y}>
                                        <text x={0} y={11} fill="currentColor" fontSize="11"><title>{exercise.name}</title>{exercise.name.length > 18 ? `${exercise.name.slice(0, 18)}…` : exercise.name}</text>
                                        <rect x={labelWidth} y={0} width={barWidth} height={14} rx={7} fill="var(--home-border)" />
                                        <rect x={labelWidth} y={0} width={scale(exercise.progressCurrent)} height={14} rx={7} fill="#6667b5" />
                                        <text x={labelWidth + barWidth + 8} y={11} fill="currentColor" fontSize="11">{percent}%</text>
                                        <text x={labelWidth} y={31} fill="currentColor" fontSize="10">Schedule elapsed</text>
                                    </Group>
                                );
                            })}
                        </svg>
                    );
                }}</ParentSize>
            </div>
            <ul className={styles.chartValues}>
                {exercises.map((exercise) => <li key={exercise.id}>{exercise.name}: {exercise.progressCurrent} of {exercise.progressTotal} schedule days elapsed.</li>)}
            </ul>
        </div>
    );
}
